export default "__VITE_ASSET__DITuZ4m0__"